import React from "react";
import { Button } from "semantic-ui-react";

const CommonButton = ({ name, click, onDisable, color, style }) => (
  <Button disabled={onDisable} onClick={click} color={color} style={style}>
    {name}
  </Button>
);

export default CommonButton;
